import React from 'react';
import { MdPieChart } from 'react-icons/md';

const DistributionBar = ({ item }) => (
    <div className="flex flex-col">
        <span className="text-sm text-gray-600">{item.key}</span>
        <div className="flex items-center gap-2">
            <div className="flex-1 h-2 bg-gray-200 rounded-full overflow-hidden">
                <div
                    className="h-full bg-darkGreen rounded-full"
                    style={{ width: `${item.value}%` }}
                />
            </div>
            <span className="text-sm font-medium text-gray-900">
                {item.value}%
            </span>
        </div>
    </div>
);

const SpendDistribution = ({ distribution }) => {
    return (
        <div className="grid grid-cols-1 sm:grid-cols-[3rem_1fr] items-center sm:items-start gap-2 sm:gap-4 hover:bg-gray-50 p-2 sm:p-3 rounded-xl transition-colors">
            <div className="w-10 h-10 sm:w-12 sm:h-12 rounded-xl bg-green-50 flex items-center justify-center shadow-sm">
                <MdPieChart className="text-2xl text-darkGreen" />
            </div>
            <div>
                <h3 className="text-sm text-gray-500 mb-2">Crop Type Delivered</h3>
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 sm:gap-4">
                    {distribution ? (
                        distribution.map((item) => (
                            <DistributionBar key={item.key} item={item} />
                        ))
                    ) : ''}
                </div>
            </div>
        </div>
    );
};

export default SpendDistribution; 